import { safeJson } from "src/app/helpers/Index";
import { faCodeCompare } from "@fortawesome/pro-light-svg-icons";
import React from "react";
import { ClubContext } from "src/app/helpers/ClubContext";
import { FitSponsorText } from "src/app/helpers/FitSponsorText";
import { Col, Row } from "react-bootstrap";
import { modes } from "react-transition-group/SwitchTransition";
import { CardType } from "src/app/enums/Index";
import { Card, Goal, Player, Substitute } from "src/app/interfaces/Index";
import { CardService, GoalService } from "src/app/services/Index";
import { SubstituteService } from "src/app/services/SubstituteService";
import "./ScoreboardLatest.css";

type Props = {};
type State = {
	compare: any[];
	mode: string;
	card: Card;
	goal: Goal;
	sub: Substitute;
};
export class ScoreboardLatest extends React.Component<Props, State> {
	
	constructor(props: Props) {
		super(props);
		this.state = {compare: [], mode: "",card: new Card, goal: new Goal,sub: new Substitute};
	}

	async componentDidMount() {
		//await this.getGoal();	
		await this.getCard();
		// await this.getSub();
		
	}
	
	render() {
		switch(this.state.mode) { 
			case "GOAL": { 
				return(
					this.renderGoal()
					);
			 } 
			 case "SUB": { 
				return(
				this.renderSub()
				); 
			 } 
			 case "CARD": { 
				return(
					this.renderCard()
					);
			 } 
		}

	}

	renderCard(){
		return (
			<div id="scoreboard-wrapper2" style={{textAlign: "center", width:576, height:432}}>
				{this.renderCardHeader()}
				<Row>
				<h3 className="yellow">{this.state.card?.cardType === CardType.Red ? "RED" : "YELLOW"} CARD</h3>
				</Row>
	
				<Row style={{height:"79%"}}>
				<Col style={{position: "relative"}}>
				<h1 style={{paddingLeft:20,paddingRight:20,float:"left",flex:0.3,flexDirection: "column",flexWrap: "wrap", alignContent: "center", whiteSpace: "break-spaces", textAlign: "center"}}><br/> {this.state.card.player?.playerName}</h1>
				</Col>
				<Col style={{position: "relative"}}><img src={this.state.card.cardType === CardType.Red ? "/assets/red-card.png" : "/assets/yellow-card.png"} width="250" style={{position: "absolute",bottom:60, right:20}}/></Col>
				</Row>	
				<Row style={{width:576,height:75, backgroundColor:"white",position:"absolute",left:12, bottom:0}}>
					<Col><img src={"https://sufc.blob.core.windows.net/uploads/debug.jpg"} height="55" style={{marginLeft:-12,marginTop:10}}/></Col>
					</Row>				
				
			</div>
		);
	}

	renderGoal(){
		return (
			<div id="scoreboard-wrapper2" style={{textAlign: "center", width:576, height:432}}>
				<Row>
				<h1 className="goal">GOAL{this.state.goal.player?.teamId === ClubContext.homeTeamId ? "!!!" : ""}</h1>
				</Row>
				<Row style={{height:"79%"}}>
				<Col style={{position: "relative"}}>
				<h2 style={{lineHeight: 1.1, marginTop: -10, paddingLeft: 10, paddingRight: 10, textAlign: "center"}}>{this.renderSplitName(this.state.goal.player?.playerName)}</h2>
				<br/>
				{this.renderSponsorship()}
				</Col>
				<Col style={{position: "relative"}}><img src={this.state.goal.player?.celebrationImage !== null ? this.state.goal.player?.celebrationImage : this.state.goal.player?.mugshotUrl} width="300" style={{position: "absolute",bottom:40, right:10}}/></Col>
				</Row>				
				
			</div>
		);
	}

	renderSub(){
		return (
			<div id="scoreboard-wrapper2" style={{ textAlign: "center", width: 576, height: 432 }}>
				<Row>
					<h1 className="sub-heading">{this.renderSubHeading()}</h1>
				</Row>
				<Row style={{ height: "79%" }}>
					<Col style={{ position: "relative" }}>
						<h2 style={{ backgroundColor: "#B22222", borderTopRightRadius: 20, borderBottomRightRadius: 20 }}>OFF - {this.state.sub.playerOff?.playerNumber}</h2>
						<img src={this.state.sub.playerOff?.mugshotUrl} width={this.state.sub.playerOff?.teamId === ClubContext.homeTeamId ? 225 : 131} style={{ position: "absolute", bottom: 20, left: 20 }} />
					</Col>
					<Col style={{ position: "relative" }}>
						<h2 style={{ backgroundColor: "limegreen", borderTopLeftRadius: 20, borderBottomLeftRadius: 20 }}>ON - {this.state.sub.playerOn?.playerNumber}</h2>
						<img src={this.state.sub.playerOn?.mugshotUrl} width={this.state.sub.playerOff?.teamId === ClubContext.homeTeamId ? 225 : 131} style={{ position: "absolute", bottom: 20, right: 20 }} />
					</Col>
				</Row>
				<Row style={{ width: 576, height: 50, backgroundColor: "#293246", position: "absolute", left: 12, bottom: 0 }}>
					<Col className="sponsor-heading">SPONSORED BY</Col>
					<Col><img src={"https://sufc.blob.core.windows.net/uploads/JS_AGroup_Shorter.jpg"} height="50" /></Col>
				</Row>

			</div>
		);
	}

	renderSplitName(name?: string) {
		if (!name) return null;
		const parts = name.trim().split(" ");
		if (parts.length < 2) return name;
		const surname = parts.pop();
		return (<>{parts.join(" ")}<br/>{surname}</>);
	}


	renderSponsorship(){
		
		if(this.state.goal.player?.teamId === ClubContext.homeTeamId) return (
			<div style={{position: "absolute",bottom:50, left:20,alignContent: "center"}}>
					<h4 style={{width:"100%"}}>SPONSORED BY:</h4>
				{this.state.goal.player?.sponsorText
					? <FitSponsorText text={this.state.goal.player.sponsorText || ""}/>
					: <img src={this.state.goal.player?.sponsor?.imageDark} width="95%"/>}
				</div>
		)
	}

	renderCardHeader(){
		
		if(this.state.card.cardType === CardType.Yellow){ return (
			<Row style={{width:576,height:75, backgroundColor: "#FFD700",position:"absolute",left:12, top:0}}>
			<Col><h3 className="yellow">YELLOW CARD</h3></Col>
		</Row>	
		)} else {
			return(
			<Row style={{width:576,height:75, backgroundColor: "#B22222",position:"absolute",left:12, top:0}}>
			<Col><h3 className="red">RED CARD</h3></Col>
		</Row>	)
		}
		
	}


	renderSubHeading() {
		if (this.state.sub.playerOff?.teamId === ClubContext.homeTeamId) return "IRON - SUBSTITUTION"
		else return "VISITOR - SUBSTITUTION"

	}

	async getCard(){
		// A board in a ground has to keep showing whatever it last had. Any of
		// these can come back empty between games, and reading .createdAt off
		// nothing would take the screen out mid-match.
		const card = await safeJson(CardService.getLatest()) || {};
		const sub = await safeJson(SubstituteService.getLatest()) || {};
		const goal = await safeJson(GoalService.getLatest()) || {};
		const compare = [];
		compare.push({name:"GOAL", value:goal.createdAt});
		compare.push({name:"SUB", value:sub.createdAt});
		compare.push({name:"CARD", value:card.createdAt});

		console.log(compare);
		var thing = compare.reduce((a, b) => a.value > b.value ? a : b);
		// this.setState({mode: thing.name});

		this.setState({card: card,sub:sub,goal:goal,compare:compare,mode:thing.name});
	}
}